import { lazy, FunctionComponent } from 'react';

export const MainLayout = lazy<FunctionComponent>(() =>
  import('./MainLayout').then(({ MainLayout }) => {
    return {
      default: MainLayout,
    };
  }),
);